var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPiplines = function SvgPiplines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F68D1",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M45 13h10v14M18 48V35h9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    fillRule: "evenodd",
    d: "M16.59 49.97a1.5 1.5 0 1 0 3 0V48.21h17.634a2 2 0 0 1 2 2v13.612a2 2 0 0 1-2 2h-25.06a2 2 0 0 1-2-2V50.209a2 2 0 0 1 2-2h4.426z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M6 4.18a2 2 0 0 0-2 2V19.79a2 2 0 0 0 2 2h37.388a2 2 0 0 0 2-2v-5.306h-3.522a1.5 1.5 0 1 1 0-3h3.522V6.18a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M29.776 26.194h22.918v2.642a1.5 1.5 0 0 0 3 0v-2.642H61a2 2 0 0 1 2 2v13.612a2 2 0 0 1-2 2H29.776a2 2 0 0 1-2-2V36.5H31.3a1.5 1.5 0 0 0 0-3h-3.523v-5.306a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  })));
};
export default SvgPiplines;